import { LatestTemplateInteractionAction } from './interfaces'

export const LATEST_TEMPLATE_INTERACTION = 'LATEST_TEMPLATE_INTERACTION'

export const updateLatestTemplateInteraction = (latestTemplateInteraction: State.LatestTemplateInteraction): LatestTemplateInteractionAction => ({
  payload: {
    latestTemplateInteraction,
  },
  type: LATEST_TEMPLATE_INTERACTION,
})
